import React from "react";
import PropTypes from 'prop-types';

class MGBadge extends React.Component {

    constructor(props, context) {
        super(props);
        this.state = {          
        }        
    }       

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    render(){
             
        var _class = "mg-ub-badge ";
         

        // if(this.props.href != undefined && this.props.href != "")
        //     return (
        //         <sup       
        //             title={this.props.title}             
        //             key={Math.random()}
        //             style={_style}
        //             className={_class}
        //             href={this.props.href}
        //         >
        //         {this.props.label}
        //         {this.props.iconBefore != "" ? <i className={_iconClass}></i> : ""}
        //         </sup>
        //     )
        // else if(this.props.actionFunc == undefined)
        // return (
        //     <sup              
        //         title={this.props.title}                   
        //         key={Math.random()}
        //         style={_style}
        //         className={_class}                                     
        //     >
        //     {this.props.label} 
        //     {this.props.iconBefore != "" ? <i className={_iconClass}></i> : ""}
        //     </sup>
        // )
        // else 
        return (
            <sup                         
                key={Math.random()}
                className={_class}>
            {this.props.badgeContent}
            </sup>
        )        
     }    
}

MGBadge.displayName = "MGBadge";

// PropTypes validation
MGBadge.propTypes = {
    actionFunc: PropTypes.func,
    href: PropTypes.string,
    title: PropTypes.string,
    class: PropTypes.string,
    primary: PropTypes.bool,
    disabled: PropTypes.bool,
    label: PropTypes.string,
    iconBefore: PropTypes.string,
};

MGBadge.contextTypes = {    
    theme: PropTypes.object
}

// default props
MGBadge.defaultProps = {
    primary: true,
    disabled: false,
    iconBefore: ""
};

export default MGBadge;